module.exports = __webpack_public_path__ + "img/hzfp28.5247b14d.png";